// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { color } from '@kintent/glide';
import { Link } from 'react-navi';

export const ComplianceStandardLogo = styled.div`
  width: 16px;
  height: 16px;

  & > img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }
`;

export const CertificationParentLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;

  cursor: pointer;

  text-decoration: none;

  &.active {
    & > span {
      color: ${({ theme }) => color(theme.colorV2.brand, 600)};
    }
  }
`;

export const MultipleDocumentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: start;

  padding-top: 16px;

  margin-left: 8px;
`;

export const DocumentLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;

  text-decoration: none;

  cursor: pointer;

  &.active {
    & > p {
      color: ${({ theme }) => color(theme.colorV2.brand, 600)};
    }
    & > svg > circle {
      fill: ${({ theme }) => color(theme.colorV2.brand, 600)};
    }
  }
`;
